'use client';

import React, { useState, useEffect } from 'react';
import { Sun, Moon, Bell, RefreshCw, Search } from 'lucide-react';
import { useTheme } from './ThemeProvider';

export default function Topbar() {
  const { theme, toggleTheme } = useTheme();
  const [refreshing, setRefreshing] = useState(false);
  const [lastUpdated, setLastUpdated] = useState('');
  const [notifCount] = useState(4);

  useEffect(() => {
    const now = new Date();
    setLastUpdated(now?.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }));
    const interval = setInterval(() => {
      setLastUpdated(new Date()?.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }));
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  const handleRefresh = () => {
    setRefreshing(true);
    setTimeout(() => {
      setRefreshing(false);
      setLastUpdated(new Date()?.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }));
    }, 1200);
  };

  return (
    <header className="h-14 flex items-center justify-between px-6 lg:px-8 border-b border-[hsl(var(--border))] bg-[hsl(var(--card))] shrink-0">
      {/* Search */}
      <div className="flex items-center gap-2 bg-[hsl(var(--muted))] rounded-lg px-3 py-1.5 w-64 group focus-within:ring-1 focus-within:ring-[hsl(var(--primary))]">
        <Search size={14} className="text-[hsl(var(--muted-foreground))]" />
        <input
          type="text"
          placeholder="Search incidents, MOC, SDS..."
          className="bg-transparent text-sm text-[hsl(var(--foreground))] placeholder:text-[hsl(var(--muted-foreground))] outline-none flex-1 w-full"
        />
        <kbd className="hidden sm:flex text-[10px] font-mono text-[hsl(var(--muted-foreground))] bg-[hsl(var(--background))] border border-[hsl(var(--border))] rounded px-1">⌘K</kbd>
      </div>

      {/* Right actions */}
      <div className="flex items-center gap-2">
        {/* Live indicator */}
        <div className="hidden sm:flex items-center gap-1.5 text-xs text-[hsl(var(--muted-foreground))]">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[hsl(var(--positive))] opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-[hsl(var(--positive))]"></span>
          </span>
          <span className="font-mono tabular-nums">Live · {lastUpdated}</span>
        </div>

        <button
          onClick={handleRefresh}
          className="p-2 rounded-lg hover:bg-[hsl(var(--muted))] text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))] transition-all duration-150"
          aria-label="Refresh data"
        >
          <RefreshCw size={15} className={refreshing ? 'animate-spin' : ''} />
        </button>

        <button
          onClick={toggleTheme}
          className="p-2 rounded-lg hover:bg-[hsl(var(--muted))] text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))] transition-all duration-150"
          aria-label="Toggle theme"
        >
          {theme === 'dark' ? <Sun size={15} /> : <Moon size={15} />}
        </button>

        <button className="relative p-2 rounded-lg hover:bg-[hsl(var(--muted))] text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))] transition-all duration-150">
          <Bell size={15} />
          {notifCount > 0 && (
            <span className="absolute top-1 right-1 w-3.5 h-3.5 rounded-full bg-[hsl(var(--negative))] text-white text-[9px] font-700 flex items-center justify-center tabular-nums">
              {notifCount}
            </span>
          )}
        </button>

        <div className="w-7 h-7 rounded-full bg-[hsl(var(--primary)/0.2)] flex items-center justify-center text-[hsl(var(--primary))] text-xs font-700 cursor-pointer">
          MR
        </div>
      </div>
    </header>
  );
}